module.exports = __webpack_public_path__ + "static/media/vue@2x.bae7dd67.png";